/********************************************
 * Hero Home Carousel
 *
 * Flickity carousel
 * https://flickity.metafizzy.co/
 ********************************************/
function fnHeroHome(i, oSection) {

    /*****************
     * Objects
     *****************/
    var oSection = $(oSection),
        oSlider = $('.slider', oSection),
        oArrows = $('.nav-arrows', oSection),
        oSlides = $('.slide', oSection),
        oSlidesImages = $('.slides-images', oSection),
        oSlidesImg = $('.slides-images > div', oSection),
        oSliderNav = $('.slider-nav', oSection),
        oSliderNavItems = $('.slider-nav li', oSection);


    /*****************
     * Slider configuration
     *****************/

    /**
     * Initialise Flickity
     */

    if (oSlides.length > 1) {
        var $oFlickity = oSlider.flickity({
            cellAlign: 'left',
            accessibility: false,
            autoPlay: false,
            pauseAutoPlayOnHover: true,
            draggable: false,
            prevNextButtons: false,
            pageDots: false,
            fade: true,
            cellSelector: '.slide'
        });

        /*
        * Slider Nav Buttons
        */

        oSliderNav.on('click', 'li', function () {
            var iIndex = $(this).index();
            console.log(iIndex);
            $oFlickity.flickity('select', iIndex);
            fnSlideChange(iIndex);
        });

        function fnSlideChange(index) {
            var iIndex = index;
            oSliderNav.find('.is-selected').removeClass('is-selected');
            $('.slide.is-selected .slider-nav li').eq(iIndex).addClass('is-selected');
            oSlidesImg.removeClass('is-selected');
            oSlidesImg.eq(iIndex).addClass('is-selected');
            oSection.removeClass('slide-1 slide-2 slide-3 slide-4 loaded');
            oSection.addClass('loaded slide-' + (iIndex + 1));
            //locoScroll.update();
        }

        /*Change Slide*/
        $oFlickity.on( 'change.flickity', function( event, index ) {
            fnSlideChange(index);
        });

        /**
         * Arrow buttons (prev/next)
         */
        oArrows.find('.next').on('click', function () {
            var iIndex = $('.slider-nav .is-selected').index();
            if(iIndex === 2){
                iIndex = 0;
            } else{
                iIndex = iIndex+1;
            }
            console.log(iIndex);
            $oFlickity.flickity('select', iIndex);
            fnSlideChange(iIndex);
        });
        oArrows.find('.previous').on('click', function () {
            var iIndex = $('.slider-nav .is-selected').index();
            if(iIndex === 0){
                iIndex = 2;
            } else{
                iIndex = iIndex-1;
            }
            console.log(iIndex);
            $oFlickity.flickity('select', iIndex);
            fnSlideChange(iIndex);
        });
    }

}


// END OF DOCUMENT
